module.exports = __webpack_public_path__ + "static/media/food.64b3538f.png";